import { onMounted, onUnmounted, ref, watch, WatchSource } from 'vue';

// Details-Popover in einer Liste: öffnet per Hover (Maus), Enter/Leertaste (Tastatur) oder Antippen (Touch).
// Bei Änderung der Quelle (z. B. Saisonwechsel) schließt das offene Popover.
export function useDetailPopover(source: WatchSource) {
  const active = ref<string | null>(null);
  const canHover = window.matchMedia?.('(hover: hover) and (pointer: fine)').matches ?? false;
  const hint = canHover ? 'Details per Hover' : 'Antippen für Details';

  const hoverOpen = (key: string) => {
    if (canHover) active.value = key;
  };
  const hoverClose = (key: string) => {
    if (canHover && active.value === key) active.value = null;
  };
  const toggle = (key: string) => {
    // Mit Maus öffnet schon der Hover – ein Klick soll das Popover dann nicht wieder schließen
    if (canHover) {
      active.value = key;
      return;
    }
    active.value = active.value === key ? null : key;
  };

  // Antippen außerhalb oder Escape schließt die Details
  const root = ref<HTMLElement | null>(null);
  const onPointerDown = (event: PointerEvent) => {
    if (active.value && root.value && !root.value.contains(event.target as Node)) active.value = null;
  };
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') active.value = null;
  };

  onMounted(() => {
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
  });
  onUnmounted(() => {
    document.removeEventListener('pointerdown', onPointerDown);
    document.removeEventListener('keydown', onKeyDown);
  });

  watch(source, () => {
    active.value = null;
  });

  return { active, root, hint, hoverOpen, hoverClose, toggle };
}
